import React from 'react'

const CurrencyFormatter: React.FC<{ value: number, className?: string }> = ({ value, className = '' }) => {
  if (value === null) {
    return <span></span>
  }

  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value)

  return <span className={className}>{formattedValue}</span>
}
export default CurrencyFormatter